import { Injectable } from '@angular/core';
import { CanvasService } from './canvas.service';
import { CanvasInputMode, CanvasInputModeService } from './canvas-input-mode.service';
import { SelectedElementsService } from './selected-elements.service';
import { ElementIntegrationService } from '@service/element-integration.service';
import { MatrixChannelService } from '@service/matrix-channel.service';
import { ElementConditionService } from '@service/element-condition.service';

@Injectable({
    providedIn: 'root',
})
export class ElementOperationsService {
    private get canvas(): any {
        return this.canvasService.getCanvas();
    }

    constructor(
        private canvasService: CanvasService,
        private canvasModeService: CanvasInputModeService,
        private selectionService: SelectedElementsService,
        private elementIntegrationService: ElementIntegrationService,
        private matrixChannelService: MatrixChannelService,
        private elementConditionService: ElementConditionService
    ) {}

    deleteSelected(hasActiveMimic: boolean): void {
        if (this.canvasModeService.getMode() == CanvasInputMode.PATH_EDIT) {
            this.canvas.pathActions.deletePathNode();
            return;
        }
        this.selectionService.getSelectedElements().forEach(element => {
            this.removeElementIntegrations(element, hasActiveMimic);
        });
        this.canvas.deleteSelectedElements();
    }

    moveSelectedBy(dx: number, dy: number): void {
        const zoom = this.canvas.getZoom();
        this.canvas.moveSelectedElements(dx * zoom, dy * zoom);
    }

    moveSelectedToFront(): void {
        this.runWithTemporaryGroup(() => this.canvas.moveToTopSelectedElement());
    }

    moveSelectedToBack(): void {
        this.runWithTemporaryGroup(() => this.canvas.moveToBottomSelectedElement());
    }

    private runWithTemporaryGroup(action: () => void): void {
        const multi = this.selectionService.getSelectedElements().length > 1;
        if (multi) this.canvas.groupSelectedElements();
        action();
        if (multi) this.canvas.ungroupSelectedElement();
    }

    private removeElementIntegrations(ele: any, hasActiveMimic: boolean): void {
        if (!hasActiveMimic) return;
        try {
            this.elementIntegrationService.deleteByElementId(ele.id);
            this.matrixChannelService.deleteByElementId(ele.id);
            this.elementConditionService.deleteByElementId(ele.id);
        } catch (err) {
            console.error(err);
        }
    }
}
